import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    :host {
        display: block;
    }

    ds-place-report {
        width: 100%;
        margin-bottom: 1em;
    }

    lit-virtualizer {
        height: 100%;
    }
`;
